import React, { MouseEventHandler, useRef, useContext, useState, useEffect } from "react";
import FindSearchPanel from "./PageFrame/HeaderItems/FindSearchPanel";
import { NotificationContext } from "./PageFrame/Header";
import { ShiftLeft, ShiftRight, ComeInFromLeft, ComeInFromRight} from "./Animator";
import OCVDialog from "../Components/OCV/OCVDialog";

type MenuItem = {
  className?: string; // Optional
  href?: string; // Optional
  onClick?: () => void; // Optional, for dynamic actions
  content: React.ReactNode; // Required, can be text or JSX
  requiredPrivilege?: string; // Required, can be text
};

type GenericDropdownProps = {
  id: string;
  containerClass?: string;
  toggleClass?: string;
  toggleText: string;
  menuItems: MenuItem[];
  isOpen: boolean;
  onMouseEnter: MouseEventHandler<HTMLDivElement>;
  onMouseLeave: MouseEventHandler<HTMLDivElement>;
  isFindMenu?: boolean;
};

const GenericDropdown: React.FC<GenericDropdownProps> = ({
  id,
  containerClass = "",
  toggleClass = "",
  toggleText = "Dropdown",
  menuItems = [],
  isOpen,
  onMouseEnter,
  onMouseLeave,
  isFindMenu = false,
}) => {

  enum AnimationTypes {
    ComeInFromRight = "ComeInFromRight",
    ShiftRight = "ShiftRight",
    ShiftLeft = "ShiftLeft",
    ComeInFromLeft = "ComeInFromLeft",
    BLANK = ""
  }

  const [showSearchPanel, setShowSearchPanel] = useState(false);
  const { setNotifications, currentUserData, FindeMenuItems, setFindMenuItems, WorkspaceMenuState, SetWorkspaceMenuState } = useContext(NotificationContext);

  const [shiftedItem, setShiftedItem] = useState<any>(null);
  const itemRefs = useRef<(HTMLAnchorElement | null)[]>([]);
  const [AnimateOnClick, setAnimateOnClick] = useState("");
  const [Animation, setAnimation] = useState<AnimationTypes>(AnimationTypes.BLANK);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const searchPanelRef = useRef<HTMLDivElement>(null);
  const [searchPlaceholder, setSearchPlaceholder] = useState("");
const [dialogVisible, setDialogVisible] = useState<boolean>(false); // Control OCVDialog visibility
  const [dialogObject, setDialogObject] = useState<any>(null);
  const handleFindClick = (item: any, index: number) => {
    setAnimateOnClick(AnimationTypes.ShiftLeft);
    setShowSearchPanel(true);
    let textContent = typeof item.content === "string" ? item.content : (item.content as any)?.props?.children;
    if (!textContent.includes("Find")){
      setSearchPlaceholder(`Find ${item.content}`);
    }
    else{
      setSearchPlaceholder(item.content);
    }
    setShiftedItem(item);
    const parentDiv = itemRefs.current[index]?.closest(".dropdown-menu-react");
    setTimeout(() => {
      requestAnimationFrame(() => {
        if (parentDiv) {
          parentDiv.classList.add("ComeInFromLeft");
        }
        SetWorkspaceMenuState((prev: any) => ({ ...prev, isFindDropDownOpen: false }));
      });
    }, 200);
  };

  const handleSearchFindClickClose = () => {
    setShowSearchPanel(false);
    SetWorkspaceMenuState((prev: any) => ({ ...prev, isFindDropDownOpen: false }));
    setAnimateOnClick(AnimationTypes.ComeInFromLeft);
    setTimeout(() => {
      setAnimateOnClick(AnimationTypes.BLANK);
    }, 860);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node) &&
        searchPanelRef.current &&
        !searchPanelRef.current.contains(event.target as Node)
      ) {
        setShowSearchPanel(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleDialogOpen = (newObject: any) => {
    setDialogObject(newObject);
    setDialogVisible(true);
  };

  return (
    <div
      className={`dropdown ${containerClass}`}
      id={id}
      onMouseEnter={showSearchPanel ? () => { setAnimateOnClick(AnimationTypes.BLANK) } : onMouseEnter}
      onMouseLeave={showSearchPanel ? () => { setAnimateOnClick(AnimationTypes.BLANK) } : onMouseLeave}
      ref={dropdownRef}
    >
      <a
        className={`foundations-dropdown-toggle cursor-pointer ${toggleClass} `}
        aria-haspopup="true"
        aria-expanded={isOpen}
      >
        {toggleText}
        <span className="image smaller">▼</span>
      </a>

      <div
        className={`dropdown-menu dropdown-menu-react home-find-dropdown-item ${isOpen ? "show" : ""} ${AnimateOnClick}`}
        aria-labelledby={`${id}_toggle`}
        style={{
          display: (isOpen && !dialogVisible) ? "block" : "none",
          position: "absolute",
        }}
      >
        {menuItems.map((item, index) => (
          <a
            key={index}
            ref={(el) => (itemRefs.current[index] = el)}
            className={`dropdown-item ${item.className || ""}`}
            onClick={(e) => {
              e.preventDefault(); // Prevent default behavior for JavaScript void links
              if (isFindMenu) {
                handleFindClick(item, index);
              } else if (item.onClick) {
                item.onClick();
              }
            }}
          >
            {item.content}
          </a>
        ))}
      </div>
      {/* Render Find Search Panel if needed */}
      {isFindMenu && showSearchPanel && (
        <div ref={searchPanelRef}>
          <FindSearchPanel 
            onClose={handleSearchFindClickClose}
            placeholder={searchPlaceholder}
            shiftedItem={shiftedItem}
            onDialogOpen={handleDialogOpen}
          />
        </div>
      )}
      {dialogVisible && dialogObject && (
        <OCVDialog
          key={dialogObject.Id}
          clickThruElement={null}
          ocvType="GenericOCV"
          launcherMode="popup"
          objectContext={dialogObject}
          onClose={() => setDialogVisible(false)}
        />
      )}
    </div>
  );
};

export default GenericDropdown;